import { Readable } from 'readable-stream';

interface StreamFileReaderOptions {
  highWaterMark?: number;
};

export default class StreamFileReader extends Readable {
  private blob: Blob;
  private offset: number;

  constructor(blob: Blob, options: StreamFileReaderOptions = {}) {
    // highWaterMark is size parameter of read.
    // default value is 65536 (64 KiB), same as fs.createReadStream
    const highWaterMark = options.highWaterMark || 65536;
    super({ highWaterMark });
    this.blob = blob;
    this.offset = 0;
    this.onLoadHandler = this.onLoadHandler.bind(this);
    this.onErrorHandler = this.onErrorHandler.bind(this);
  }

  _read(size: number) {
    if (this.offset >= this.blob.size) {
      this.push(null);
      return;
    }
    const chunk = this.blob.slice(this.offset, this.offset + size, this.blob.type);
    this.offset += size;
    const reader = this.fileReader();
    reader.readAsArrayBuffer(chunk);
  }

  private fileReader() {
    const reader = new FileReader();
    reader.onload = this.onLoadHandler;
    reader.onerror = this.onErrorHandler;
    return reader;
  }

  private onLoadHandler(event: ProgressEvent) {
    const target = event.target as FileReader;
    if (target.result instanceof ArrayBuffer) {
      this.push(Buffer.from(target.result));
    }
  }

  private onErrorHandler(event: ProgressEvent) {
    const target = event.target as FileReader;
    target.abort();
    this.emit('error', target.error);
  }
}
